import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { useEffect, useState } from 'react'

dayjs.extend(duration)

export const useCountdown = (targetTimestamp) => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(targetTimestamp))

  useEffect(() => {
    const interval = setInterval(() => {
      // for better performance. set only if current browser tab is active
      if (document.visibilityState === 'visible') {
        // console.log(dayjs().valueOf())
        setTimeLeft(getTimeLeft(targetTimestamp))
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [targetTimestamp])

  return timeLeft
}

function getTimeLeft(target) {
  const now = dayjs()
  const diff = target - now.valueOf()

  if (diff <= 0) {
    return { hours: '00', minutes: '00', seconds: '00' }
    // return '00 год. 00 хв. 00 сек.'
  }

  const dur = dayjs.duration(diff)
  // console.log(dur)

  const totalHours = Math.floor(dur.asHours())
  const minutes = dur.minutes()
  const seconds = dur.seconds()

  return {
    // hours: String(dur.hours()).padStart(2, '0'),
    hours: String(totalHours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  }

  // const hours = String(dur.hours()).padStart(2, '0')
  // const minutes = String(dur.minutes()).padStart(2, '0')
  // const seconds = String(dur.seconds()).padStart(2, '0')

  // return `${hours} год. ${minutes} хв. ${seconds} сек.`
}
